import { render } from "./ViewUser.vue?vue&type=template&id=059ba8bf"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/saes/central_authentication/central_authentication_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__